'use client'

import * as devtools from './devtools'

export const ReactQueryDevtools = devtools.ReactQueryDevtools
